import React from 'react';
import '../../App.scss';
import AuthorizedPage from '../../component/AuthorizedPage';
import { Role } from '../../domain/Role';

class Home extends React.Component<any,any> {

  constructor(props: any) {
    super(props);
    // Don't call this.setState() here!
  }

  render() {
  return (
        <AuthorizedPage role={Role.BACKOFFICE_ADMIN}>
          <div className="login-pane centered-80-percent colorize-borders">
              <p>Hoş geldiniz!</p>
          </div>
        </AuthorizedPage>
    )
  }
}

export default Home;
